import { BackButton, Divider, Form, FormInput, Header, useAlignments, useSizes } from 'metrix-common3';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const ProfileDwellingImprovement = (props) => {
    const sizes = useSizes();
    const alignments = useAlignments();

    return (
        <React.Fragment>
            <BackButton clickEvent={props.backEvent} />
            <Divider top={sizes.md} />
            <Header
                size={sizes.md}
                textAlign={alignments.left}
                text={<FormattedMessage id='Profile_Dwellings_Improvement.improvement' />}
            />
            <Form
                label={<FormattedMessage id='Profile_Dwellings_Improvement.improvementDetails' />}
                allowEdit={props.allowEdit}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
            >
                <FormInput
                    label={<FormattedMessage id='Profile_Dwellings_Improvement.description' />}
                    value={props.improvement?.otherImprovement?.value}
                    changeEvent={(value) => {
                        props.doReducePolicyElement({ code: `${props.dotProp}otherImprovement.value`, value });
                    }}
                    allowEdit
                />
                <FormInput
                    label={<FormattedMessage id='Profile_Dwellings_Improvement.value' />}
                    value={props.improvement?.otherImprovementAmount?.value}
                    changeEvent={(value) => {
                        props.doReducePolicyElement({ code: `${props.dotProp}otherImprovementAmount.value`, value });
                        props.doReducePolicyElement({
                            code: `${props.dotProp}otherImprovementAmount.currency`,
                            value: 'cad',
                        });
                    }}
                    allowEdit
                />
            </Form>
        </React.Fragment>
    );
};

export default ProfileDwellingImprovement;
